import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import urlJoin from 'url-join';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CaseService {
  private urlOpenBanking = environment.urlOpenBanking;

  constructor(private http: HttpClient) {}

  abortCase(userToken: string, userId: string): Observable<void> {
    const abortUrl = urlJoin(this.urlOpenBanking, 'users', userId, 'open-banking-case-clerk', 'abort');

    return new Observable((observer) =>
      this.http
        .post<void>(abortUrl, undefined, {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        })
        .subscribe({
          next: () => {
            observer.next();
          },
          error: () => {
            this.failCase(userToken, userId).subscribe(() => {
              observer.next();
            });
          },
        })
    );
  }

  failCase(userToken: string, userId: string): Observable<void> {
    const failUrl = urlJoin(this.urlOpenBanking, 'users', userId, 'open-banking-case-clerk', 'fail');

    return new Observable((observer) =>
      this.http
        .post<void>(failUrl, undefined, {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        })
        .subscribe({
          next: () => {
            observer.next();
          },
          error: () => {
            observer.next();
          },
        })
    );
  }
}
